"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReservationStage;
(function (ReservationStage) {
    ReservationStage[ReservationStage["NOT_TO_STAGE_ONE"] = 0] = "NOT_TO_STAGE_ONE";
    ReservationStage[ReservationStage["STAGE_ONE"] = 1] = "STAGE_ONE";
    ReservationStage[ReservationStage["NOT_TO_STAGE_TWO"] = 2] = "NOT_TO_STAGE_TWO";
    ReservationStage[ReservationStage["STAGE_TWO"] = 3] = "STAGE_TWO";
    ReservationStage[ReservationStage["NOT_TO_STAGE_THREE"] = 4] = "NOT_TO_STAGE_THREE";
    ReservationStage[ReservationStage["STAGE_THREE"] = 5] = "STAGE_THREE";
})(ReservationStage = exports.ReservationStage || (exports.ReservationStage = {}));
var ReservationSkuStatus;
(function (ReservationSkuStatus) {
    ReservationSkuStatus[ReservationSkuStatus["NO_RESERVATION_TIME"] = 0] = "NO_RESERVATION_TIME";
    ReservationSkuStatus[ReservationSkuStatus["RESERVATION_TIME"] = 1] = "RESERVATION_TIME";
    ReservationSkuStatus[ReservationSkuStatus["SIGN_UP_TIME"] = 2] = "SIGN_UP_TIME";
    ReservationSkuStatus[ReservationSkuStatus["SIGN_UP_END"] = 3] = "SIGN_UP_END";
})(ReservationSkuStatus = exports.ReservationSkuStatus || (exports.ReservationSkuStatus = {}));
var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus[ReservationStatus["NEW_USER"] = 0] = "NEW_USER";
    ReservationStatus[ReservationStatus["NOT_RESERVED"] = 1] = "NOT_RESERVED";
    ReservationStatus[ReservationStatus["NOT_IN_GROUP"] = 2] = "NOT_IN_GROUP";
    ReservationStatus[ReservationStatus["RESERVED"] = 3] = "RESERVED";
    ReservationStatus[ReservationStatus["ENROLLED"] = 4] = "ENROLLED";
    ReservationStatus[ReservationStatus["CAN_NOT_PURCHASE"] = 5] = "CAN_NOT_PURCHASE";
})(ReservationStatus = exports.ReservationStatus || (exports.ReservationStatus = {}));
//# sourceMappingURL=reservation.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/reservation.js
// module id = 1005
// module chunks = 0